(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qm-header"] && !Shopify.designMode) return;
  try {
    
function qmBindCatalog(root) {
  const menu = root.querySelector('.qm-catalog');
  const toggle = menu?.querySelector('.qm-menu-toggle');
  if (!toggle || toggle.dataset.bound) return;
  toggle.dataset.bound = 'true';
  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    menu.classList.toggle('is-open', expanded);
  });
  menu.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  });
}
qmBindCatalog(document);
document.addEventListener('shopify:section:load', event => qmBindCatalog(event.target));

  } catch(e) { console.error(e); }
})();
})();
